// v295a-image-perf-round2
// OptImg with feste srcSet-Breiten + externe Whitelist
import React from 'react';

const API = process.env.REACT_APP_BACKEND_URL || '';

const PROXY_HOSTS = new Set([
  'shop.trxl-performance.de', 'www.trxl-performance.de', 'trxl-performance.de',
  'static.prod-images.emergentagent.com',
  'customer-assets-v7afamib.emergentagent.net',
  'customer-assets.emergentagent.com',
  'maxtondesign.com', 'www.maxtondesign.com',
  'goapr-prod.nbg1.your-objectstorage.com',
  'cdn.milltek.com', 'www.milltek.com',
  'www.hg-motorsport.de', 'www.eibach.com', 'eibach.de',
  'www.kw-suspension.de', 'www.h-r.com', 'www.bilstein.com',
  'www.friedrich-motorsport.de', 'www.hjs.com',
  'www.rieger-tuning.de', 'bastuck.de', 'www.bastuck.de',
]);
const OWN_UPLOAD_RE = /^\/(?:api\/)?uploads\//i;
const DEFAULT_WIDTHS = [400, 800, 1200, 1600];

function isProxyable(src) {
  if (!src || typeof src !== 'string') return false;
  if (OWN_UPLOAD_RE.test(src)) return true;
  try {
    const origin = (typeof window !== 'undefined') ? window.location.origin : 'https://shop.trxl-performance.de';
    const u = new URL(src, origin);
    if (PROXY_HOSTS.has(u.hostname)) {
      if (u.hostname.endsWith('trxl-performance.de')) {
        return OWN_UPLOAD_RE.test(u.pathname) || u.pathname.startsWith('/storage/');
      }
      return true;
    }
  } catch (_e) {}
  return false;
}

function proxyUrl(src, w) {
  if (!isProxyable(src)) return src;
  const params = new URLSearchParams({ src });
  if (w > 0) params.set('w', String(w));
  return `${API}/api/img?${params.toString()}`;
}

export function bgUrl(src, width = 1600) {
  return proxyUrl(src, width);
}

export default function OptImg({
  src, alt = '', width = 800, height, sizes,
  priority = false, widths, className, style, onClick, onLoad, ...rest
}) {
  if (!src) return null;
  const sizeAttr = sizes || '(max-width: 640px) 100vw, (max-width: 1024px) 90vw, 1400px';

  if (!isProxyable(src)) {
    return (
      <img src={src} alt={alt} width={width} height={height}
        className={className} style={style} onClick={onClick} onLoad={onLoad}
        loading={priority ? 'eager' : 'lazy'} decoding="async"
        {...(priority ? { fetchpriority: 'high' } : {})}
        {...rest} />
    );
  }

  const ws = (widths && widths.length) ? widths : DEFAULT_WIDTHS;
  const srcSet = ws.map(w => `${proxyUrl(src, w)} ${w}w`).join(', ');
  const fallback = ws.reduce((prev, cur) => Math.abs(cur - width) < Math.abs(prev - width) ? cur : prev, ws[0]);

  return (
    <img src={proxyUrl(src, fallback)} srcSet={srcSet} sizes={sizeAttr}
      alt={alt} width={width} height={height}
      className={className} style={style} onClick={onClick} onLoad={onLoad}
      loading={priority ? 'eager' : 'lazy'} decoding="async"
      {...(priority ? { fetchpriority: 'high' } : {})}
      {...rest} />
  );
}
